@if (isEditMode() && treeModel) {
  <p-tree class="w-full md:w-30rem" [value]="treeModel" >
    <ng-template let-node pTemplate="section">
      <span (click)="jumpToSection(node.data)" title="Jump to top of {{node.label}}" [innerHtml]="node.icon+' '+node.label"></span>
    </ng-template>
  </p-tree>
}
@if (isEditMode() && treeModel) {
  <hr />
}
@if (model.length > 0) {
  <ul class="layout-menu">
    @for (item of model; track item; let i = $index) {
      @if (!item.separator) {
        <li app-menuitem [item]="item" [index]="i" [root]="true"></li>
      }
      @if (item.separator) {
        <li class="menu-separator"></li>
      }
    }
    <!-- li>
    <a href="https://www.primefaces.org/primeblocks-ng/#/">
      <img src="assets/layout/images/{{layoutService.config.colorScheme === 'light' ? 'banner-primeblocks' : 'banner-primeblocks-dark'}}.png" alt="Prime Blocks" class="w-full mt-3"/>
    </a>
    </li -->
  </ul>
}

